import {Heading, SimpleGrid, Text} from '@chakra-ui/react';
import React from 'react';
import FlexCard from '../../../General/FlexCard';
import {CustomInput} from '../../../General/FormInputs';

const OppIndividual = ({register, errors}) => {
  return (
    <FlexCard w="35%">
      <SimpleGrid columns={3}>
        <Heading size="md">Individual</Heading>
        <Heading size="md">Funeral</Heading>
        <Heading size="md">Cremation</Heading>

        <Text>A/R Balance</Text>
        <CustomInput register={register} errors={errors} id="emArbal" requireInt />
        <CustomInput register={register} errors={errors} id="emCremar" requireInt />

        <Text>E&O</Text>
        <CustomInput register={register} errors={errors} id="emEo" requireInt />
        <CustomInput register={register} errors={errors} id="emCremeo" requireInt />

        <Text>Max Bonus</Text>
        <CustomInput register={register} errors={errors} id="emMaxbon" requireInt />
        <Text></Text>

        <Text>Target Rev</Text>
        <CustomInput register={register} errors={errors} id="emTarget" requireInt />
        <Text></Text>

        <Text>Discounts</Text>
        <CustomInput register={register} errors={errors} id="emDisc" requireInt />
        <Text></Text>

        <Text>Add'l Rev</Text>
        <CustomInput register={register} errors={errors} id="emArevfi" requireInt />
        <CustomInput register={register} errors={errors} id="emArevci" requireInt />
      </SimpleGrid>
    </FlexCard>
  );
};

export default OppIndividual;
